import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import childhoodCancerImageDesktopWebp from './images/childhood-cancer-desktop.webp';
import childhoodCancerImageMobileWebp from './images/childhood-cancer-mobile.webp';
// base urls
import { nmFoundationBaseUrl } from '../../../../../utils/unsecuredLinks';

export default () => (
  <InformationalModule
    // configs
    sectionId='sustainability-impact-communities-childhood-cancer'
    themeType='lightTheme'
    backgroundVariant='lightB'
    moduleName='financial-planning-module'
    moduleVariation='A'
    reverseContent
    // content
    subHeadingText={<>Childhood cancer: Advancing research, <WidowBlock>supporting families</WidowBlock></>}
    // column content
    columnContentA={(
      <>
        <Typography nextElement='typography'>
          We&#39;re committed to accelerating the search for better treatments and cures for childhood cancer. We support families during treatment and survivors living with the long&#45;term effects of a diagnosis.
        </Typography>
        <Typography nextElement='button'>
          We partner with a wide range of organizations, including Alex&#39;s Lemonade Stand Foundation&#8212;a leader in advancing innovative and underfunded childhood cancer research. We continue to be inspired by the progress in cancer research driven by the grants we&#39;ve funded through our partnerships and the efforts of our people nationwide.
        </Typography>
        <Link
          id='sustainability-impact-communities-childhood-cancer-link'
          variant='buttonLinkSecondary'
          linkUrl={`${nmFoundationBaseUrl}/childhood-cancer/`}
          ariaLabel='Find out more about how we are advancing research for childhood cancer.'
          isInternalPdf>
          Find out more
        </Link>
      </>
    )}
    // image props
    imageAltText='Child excitedly meets a baseball player on the field'
    imageSrcDefault={childhoodCancerImageDesktopWebp}
    imageSrcMobile={childhoodCancerImageMobileWebp}
  />
);
